import React from 'react'
import { IconProps } from './icons.types'

export const RadioOff: React.FC<IconProps> = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 1.875V16.125M12.875 6.75V11.25M6.125 6.75L6.125 11.25M16.25 8.81249V9.18751M2.75 8.81249L2.75 9.18751"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
